import React from 'react';
import { Card, Table, Button } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import AllocationWarnings from './AllocationWarnings';
import CommitteeBanner from '../CommitteeBanner';

const CommitteeAllocationCard = ({
  committee,
  allocations,
  getCouncilMemberOptions,
  allocationWarnings,
  onAllocationChange,
  onSave,
  isSaving,
  selectStyles,
}) => (
  <div className="committee-section">
    <CommitteeBanner name={committee.committeeName} />
    <Card className="card-two table-responsive">
      <Card.Body>
        <Table responsive bordered hover className="mb-0">
          <thead>
            <tr>
              <th className="col-rank text-center">Rank</th>
              <th className="col-candidate p-3">Candidate Name</th>
              <th className="col-council p-3">Allocated Council Member</th>
            </tr>
          </thead>
          <tbody>
            {committee.nominations.map((nomination) => (
              <tr key={nomination.nominationId}>
                <td className="text-center">
                  <strong>{nomination.rank}</strong>
                </td>
                <td className="p-3">{nomination.candidateName}</td>
                <td className="p-3">
                  <Select
                    value={allocations[nomination.nominationId]}
                    options={getCouncilMemberOptions(
                      nomination.rank,
                      nomination.candidateId,
                      nomination.nominationId,
                      nomination.electionTypeId,
                    )}
                    onChange={(selectedOption) =>
                      onAllocationChange(
                        nomination.nominationId,
                        selectedOption,
                        committee.committeeId,
                      )
                    }
                    styles={selectStyles}
                    placeholder="Select council member..."
                    menuPosition="fixed"
                    isClearable
                  />
                  <AllocationWarnings
                    warnings={allocationWarnings[nomination.nominationId]}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="text-end mt-3">
          <Button
            variant="success"
            className="standard-width-button"
            onClick={() =>
              onSave(committee.committeeId, committee.committeeName)
            }
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </Card.Body>
    </Card>
  </div>
);

CommitteeAllocationCard.propTypes = {
  committee: PropTypes.shape({
    committeeId: PropTypes.number.isRequired,
    committeeName: PropTypes.string.isRequired,
    nominations: PropTypes.arrayOf(
      PropTypes.shape({
        nominationId: PropTypes.number.isRequired,
        nominationStateId: PropTypes.number.isRequired,
        rank: PropTypes.number.isRequired,
        candidateName: PropTypes.string.isRequired,
        candidateId: PropTypes.number.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  allocations: PropTypes.object.isRequired,
  getCouncilMemberOptions: PropTypes.func.isRequired,
  allocationWarnings: PropTypes.object.isRequired,
  onAllocationChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  selectStyles: PropTypes.object.isRequired,
};

export default CommitteeAllocationCard;
